<template>
  <BaseModal
    :title="_T('@Wheel popup title')"
    :modal-width="1245"
    title-color="white"
    :background-image="
      !isMobile
        ? componentsConfig[currentComponent].backgroundImage
        : componentsConfig[currentComponent].backgroundAdaptiveImage
    "
    header-background-color="rgba(255, 255, 255, 0.2)"
    close-button-color="white"
    @on-close-modal="onCloseModal"
  >
    <div class="wheel-modal__container">
      <Component
        :is="componentsConfig[currentComponent].component()"
        v-model="prize"
        @on-change-component="onChangeComponent"
      />
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "~/modules/shared/modals/BaseModal.vue";
import {
  useModalStore,
  wheelModal,
} from "~/modules/shared/modals/store/modalStore.js";

const modalStore = useModalStore();

const prize = ref(null);
const currentComponent = ref("starter");

const componentsConfig = {
  starter: {
    component: () => {
      return defineAsyncComponent(
        () =>
          import("~/modules/shared/modals/components/WheelModal/Starter.vue"),
      );
    },
    backgroundImage: "url('/img/fortune-wheel/starter-background.png')",
    backgroundAdaptiveImage:
      "url('/img/fortune-wheel/starter-adaptive-background.png')",
  },
  form: {
    component: () => {
      return defineAsyncComponent(
        () =>
          import("~/modules/shared/modals/components/WheelModal/PrizeForm.vue"),
      );
    },
    backgroundImage: "url('/img/fortune-wheel/form-background.png')",
    backgroundAdaptiveImage:
      "url('/img/fortune-wheel/finished-adaptive-background.jpg')",
  },
  finished: {
    component: () => {
      return defineAsyncComponent(
        () =>
          import("~/modules/shared/modals/components/WheelModal/Finished.vue"),
      );
    },
    backgroundImage: "url('/img/fortune-wheel/finished-background.png')",
    backgroundAdaptiveImage:
      "url('/img/fortune-wheel/finished-adaptive-background.jpg')",
  },
};

onMounted(() => {
  document.documentElement.style.overflow = "hidden";
});

function onCloseModal() {
  modalStore.toggleModal(wheelModal);
}

const onChangeComponent = (component) => {
  currentComponent.value = component;
};

const isMobile = computed(() => {
  return useWindowSize().width.value <= 1024;
});

onUnmounted(() => {
  document.documentElement.style.overflow = "auto";
});
</script>

<style scoped lang="scss">
.wheel-modal__container {
  min-height: 400px;

  @include flex-container(row, center, center);

  @include mobile {
    min-height: 200px;
  }
}
</style>
